/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
/* eslint-disable no-undef */
/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import React, { useCallback, useState, useMemo, useContext, useEffect } from 'react';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss'
import TWIARepairsOrAdditionsComponent from 'ent-capability-quoteandbind-common-react/components/ConstructionDetails/TWIARepairsOrAdditionsComponent/TWIARepairsOrAdditionsComponent';
import TWIARoofUpdatesComponent from 'ent-capability-quoteandbind-common-react/components/ConstructionDetails/ENTRoofUpdatesComponent/ENTRoofUpdatesComponent';
import { CpCoverablesService } from 'twia-capability-quoteandbind-cp';
import { InlineNotification, Loader } from '@jutro/components';
import _ from 'lodash';
import { BldgLocContext } from '../../../context/BuildingsAndLocationContext';
import metadata from './ConstructionStep.metadata.json5';
import TWIABuildingLocationAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingLocationAccordion/TWIABuildingLocationAccordion';
import TWIABuildingInfoAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingInfoAccordion/TWIABuildingInfoAccordion';
import TWIACPConstructionDetails from '../../TWIACPConstructionDetails/TWIACPConstructionDetails';
import TWIAWizardMessagesMessages from '../../../../../modules-react/twia-portals-wizard-components-ui/common/TWIAWizardMessages.messages';
import { TranslatorContext } from '@jutro/locale';

function ConstructionStep(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { id, submissionVM, updateWizardData, handleNextClick, handleCancelClick, handleEditLinkClick, isCommercial, showStepper, editLocationBuilding } = props;
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation, setSelectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const [buildingVM, setBuildingVM] = useState(selectedLocation.buildings.children[selectedBuildingIndex]);
    const { refreshData } = useDataRefresh();
    const translator = useContext(TranslatorContext);
    const [isLoading, setIsLoading] = useState(false); // DE18801
    const { isComponentValid, onValidate } = useValidation(id);
    const [showErrors, setShowErrors] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorSets, setErrorSets] = useState([]);
    const { authHeader } = useAuthentication();
    const [invalidComponent, setInvalidComponents] = useState([]);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const viewModelService = useContext(ViewModelServiceContext);
    const locations = submissionVM.lobData.commercialProperty.coverables.locations.value
    const locationIndex = _.findIndex(locations, (loc) => loc.publicID === chosenLocation[0].publicID.value); // DE15785
    const jobID = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value');
    const sessionID = submissionVM.sessionUUID.value;
    const [address, updateAddress] = useState('');
    const [oldSubmissionData, setOldSubmissionData] = useState();

    // 2024-07-06 - Debra Frum - US26267 - Commercial Quote - Buildings and Locations – Construction Screen – Roofing Updates
    // Roofing Updates aren't available for Builder's Risk coverage form or risk item types that don't have roofs
    const RISK_ITEM_TYPES_WITHOUT_ROOF =
        ['AntennaDish', 'Fence', 'FlagPole','FloodLightsOrLightPole', 'ScoreBoard', 'Sign', 'SwimmingPool', 'TennisCourtSurface'];
    const isRiskItemTypeWithoutRoof = (riskItemType) => RISK_ITEM_TYPES_WITHOUT_ROOF.includes(riskItemType);
    const isRoofingUpdatesVisible = () => {
        return !_.isNil(buildingVM.coverageForm)
            && !_.isNil(buildingVM.coverageForm.value)
            && buildingVM.coverageForm.value.code !== 'TWCR'
            && !_.isNil(buildingVM.riskItemType_TWIA)
            && !_.isNil(buildingVM.riskItemType_TWIA.value)
            && !isRiskItemTypeWithoutRoof(buildingVM.riskItemType_TWIA.value.code);
    };

    useEffect(() => {
        const oldData = _.cloneDeep(submissionVM.value)
        setOldSubmissionData(oldData)
        setBuildingVM(buildingVM)
        updateAddress(_.get(submissionVM, `lobData.commercialProperty.coverables.locations.value[${locationIndex}].address`));
    }, [])

    const updateSubmissionData = useCallback((vm) => {
        setBuildingVM(vm)
        _.set(submissionVM, `lobData.commercialProperty.coverables.locations.value[${locationIndex}].buildings[${selectedBuildingIndex}]`, vm.value)
        updateWizardData(submissionVM)
    }, [locationIndex, selectedBuildingIndex, submissionVM, updateWizardData])

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const errorContent = useCallback(
        item => {
            return (
                <InlineNotification id={item} 
                message={item}
                type= "error"
                className= {wizardStyles.marginBottom}
                isDismissable= {false}
                />
            );
        },
        []
    );

    const generateOverrides = useMemo(() => {
        const overrides = errorSets.map((item, index) => {
            return {
                [`errorMsg${index}`]: {
                    content: errorContent(item),
                },
            };
        });
        return Object.assign({}, ...overrides);
    }, [errorSets, errorContent]);
    
    // can add other issues/warning messages based on requirement
    const getErrorMessages = useCallback ((validationIssues) => {
        if (validationIssues && ((validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0 ))) {
            let flowErrors = [];
            if (validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0 ) {
                flowErrors = validationIssues.fieldIssues.filter((item) => {
                    return item.flowStepId === "CPBuildings";
                }).map((item, index) => {
                    return (`${item.relatedEntity.displayName} ${item.reason}`); // to display [BuildingNumber]: Building # [BuildingNumber] before error message.
                });
            }
            refreshData();
            const messages = [...flowErrors];

            if(messages.length > 0) {
                setShowErrorMessage(true);
                setErrorSets(messages);
                return true;
            } else {
                setShowErrorMessage(false);
                setErrorSets([]);
                return false;
            }
            

        } else {
            setShowErrorMessage(false);
            setErrorSets([]);
            refreshData();
            return false;
        }
        
    }, [setShowErrorMessage, setErrorSets, refreshData]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        // 2024-06-21 - Debra Frum - US26267 - Commercial Quote - Buildings and Locations – Construction Screen – Roofing Updates
        // Roofing Updates aren't available for Builder's Risk coverage form or risk item types that don't have roofs
        roofAccordion: {
            visible: isRoofingUpdatesVisible()
        },
        repairContainer: {
            visible: buildingVM.coverageForm.value.code !== 'TWCR'
        },
        roofUpdates: {
            submissionVM,
            updateWizardData,
            showErrors,
            findInvalidComponent,
            onValidate,
            selectedBuilding: buildingVM,
            isCommercial
        },
        repairsOrAdds: {
            submissionVM,
            updateWizardData,
            showErrors,
            findInvalidComponent,
            onValidate,
            selectedBuilding: buildingVM,
            isCommercial
        },
        locationAccordion: {
            visible: showStepper,
            handleEditLinkClick
        },
        buildingAccordion: {
            visible: showStepper,
            handleEditLinkClick
        },
        nextButton: {
            content: !showStepper ? translator(TWIAWizardMessagesMessages.TWIAWizardModalSave)
                : translator(TWIAWizardMessagesMessages.TWIAWizardModalNext)
        },
        wizardActionButtons: {
            justifyContent: !showStepper ? 'right' : 'between'
        },
        // Added Construction Details Section for Construction Step
        cpConstructionDetailsComponent: {
            submissionVM,
            updateWizardData,
            selectedBuilding: buildingVM,
            updateSubmissionData,
            address,
            showErrorsConstruction: showErrors,
            findInvalidComponent,
            onValidate,
            editLocationBuilding
        },
        inforMessage: {
            data: errorSets
        },
        ...generateOverrides,
    }

    const cancelBuilding = useCallback(async () => {
        // DE15976
        _.extend(submissionVM.value, oldSubmissionData)
        const locationValue = _.get(submissionVM, `lobData.commercialProperty.coverables.locations.children[${locationIndex}]`);
        updateWizardData(submissionVM)
        await handleCancelClick(locationValue, setSelectedLocation);
    }, [handleCancelClick, selectedLocation, setSelectedLocation, oldSubmissionData, submissionVM]);

    const saveData = useCallback(async () => {
        try {
            // const newSubmissionVM = viewModelService.clone(submissionVM);
            setIsLoading(true);
            const result = await CpCoverablesService.updateCPBuilding(
                jobID,
                selectedLocation.publicID.value, 
                buildingVM.value, sessionID, authHeader
            );
            // US26243
            _.set(submissionVM, `lobData.commercialProperty.coverables.locations.value[${locationIndex}].buildings[${selectedBuildingIndex}]`, result);
            setSelectedLocation(_.get(submissionVM, `lobData.commercialProperty.coverables.locations.children[${locationIndex}]`));
            updateWizardData(submissionVM);
            setIsLoading(false);
            if (result.errorsAndWarnings_TWIA) {
                const errors = getErrorMessages(result.errorsAndWarnings_TWIA.validationIssues);

                if(errors === false) {
                    setShowErrors(false);
                    handleNextClick();
                    setIsLoading(false);
                    return submissionVM;
                } else if (errorSets.length > 0){
                    setShowErrors(true);
                    setIsLoading(false);
                    return false;
                }
            }
            setIsLoading(false);
        } catch {
            setIsLoading(false);
            return submissionVM
        }
    }, [jobID, selectedLocation, buildingVM, sessionID, authHeader, 
        submissionVM, locationIndex, selectedBuildingIndex, setSelectedLocation, 
        updateWizardData, getErrorMessages, errorSets, handleNextClick]);

    const onNext = useCallback(async () => {
        if (invalidComponent.length > 0) {
            setShowErrors(true)
            return false;
        }
        setShowErrors(false);
        return saveData()
    }, [invalidComponent, saveData]);

    const resolvers = {
        resolveComponentMap: {
            roofUpdatesComponent: TWIARoofUpdatesComponent,
            repairsOrAddsComponent: TWIARepairsOrAdditionsComponent,
            TWIABuildingLocationAccordion,
            TWIABuildingInfoAccordion,
            TWIACPConstructionDetails
        },
        resolveCallbackMap: {
            handleCancelClick: cancelBuilding,
            onNext
        },
        resolveClassNameMap: wizardStyles,
    };

    return (
        <Loader loaded={!isLoading}>
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            onModelChange={updateWizardData}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showErrors}
        />
        </Loader>
    )
}

export default ConstructionStep
